<script>
    // import all images from this folder
    import gaming from 'src/components/main/home/components/advantages/gaming.svg'
    import token from 'src/components/main/home/components/advantages/token.svg'
    import marketplace from 'src/components/main/home/components/advantages/marketplace.svg'
</script>

<section>
    <div class="container">
        <div class="title">Competitive advantages</div>
        <div class="description">We are the bridge between games and the blockchain world. Realis makes it possible to use blockchain technology by simply enjoying the gameplay.</div>
        <div class="background">
            <div class="block">
                <div class="row">
                    <div class="col-md-4">
                        <div class="advantage-card">
                            <img src="{token}" alt="Valuable Currency">
                            <div class="subtitle">Valuable Currency</div>
                            <div class="text">LIS Token - valuable in-game currency that users can get and use in our games, as well as withdraw it into wallets and exchanges.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="advantage-card reverse">
                            <img src="{gaming}" alt="Gaming">
                            <div class="subtitle">Gaming</div>
                            <div class="text">Games first, everything else the next. We believe if the game isn’t interesting, blockchain will be not interesting too. That is why we are focusing on game design and retention rate.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="advantage-card">
                            <img src="{marketplace}" alt="Utility NFT">
                            <div class="subtitle">Utility NFT</div>
                            <div class="text">We are against JPEG NFTs. Our NFTs have real utility and we think that it's the future.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        margin: 200px 0 150px;
        position: relative;
        z-index: 2;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 10px 0 30px;
        line-height: normal;
        text-align: center;
    }

    .description {
        color: #CED5E3;
        font-size: 20px;
        margin: 0 auto 100px;
        line-height: normal;
        max-width: 620px;
        text-align: center;
    }

    .background {
        border-radius: 15px;
        background: linear-gradient(0deg, #0e1417 20%, #767bb7);
        padding: 1px;
    }

    .block {
        background: linear-gradient(0deg, #02080b 20%, #0c121b);
        border-radius: 15px;
        width: 100%;
        padding: 70px;
    }

    .advantage-card {
        border-radius: 12px;
        padding: 30px;
        background: linear-gradient(180deg, #1E222B 0%, rgba(40, 45, 57, 0.00) 100%);
    }

    .advantage-card.reverse {
        background: linear-gradient(180deg, rgba(40, 45, 57, 0.00) 0%, #1E222B 100%);
    }

    .subtitle {
        font-size: 30px;
        color: white;
        line-height: normal;
        font-family: 'Anton', sans-serif;
        margin: 40px 0 20px;
    }

    .text {
        color: #A0AEC0;
        font-size: 16px;
        line-height: 1.5;
    }

    @media(max-width: 1199px) {
        section {
            margin: 100px 0 150px;
        }

        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 20px;
        }

        .description {
            margin-bottom: 30px;
        }

        .block {
            padding: 30px;
        }

        .text {
            font-size: 15px;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 30px;
            text-align: center;
        }

        .description {
            text-align: center;
            max-width: 700px;
            margin: 0 auto 40px;
        }

        .block {
            padding: 12px;
        }

        .advantage-card {
            padding: 12px;
        }

        .subtitle {
            margin: 26px 0 12px;
            font-size: 24px;
        }
    }

    @media(max-width: 767px) {
        section {
            margin: 40px 0 60px;
        }

        .title {
            font-size: 40px;
            line-height: 1.3;
        }

        .description {
            font-size: 16px;
        }

        .background {
            background: transparent;
            padding: 0;
        }

        .block {
            padding: 0;
            background: transparent;
        }

        .advantage-card {
            margin-bottom: 20px;
        }

        .advantage-card.reverse {
            background: linear-gradient(180deg, #1E222B 0%, rgba(40, 45, 57, 0.00) 100%);
        }

        .advantage-card img {
            position: absolute;
        }

        .subtitle {
            margin: 0 0 10px;
            font-size: 24px;
            padding-left: 90px;
        }

        .text {
            font-size: 15px;
            padding-left: 90px;
        }
    }
</style>
